module.exports = __webpack_public_path__ + "img/icon_menu_instagram_darkgrey.1fa3d4e8.svg";